import { render, staticRenderFns } from "./loginRecommend.vue?vue&type=template&id=4228f265&scoped=true"
import script from "./loginRecommend.vue?vue&type=script&lang=js"
export * from "./loginRecommend.vue?vue&type=script&lang=js"
import style0 from "./loginRecommend.vue?vue&type=style&index=0&id=4228f265&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4228f265",
  null
  
)

export default component.exports